/* HIBA generic product-family picker (swatch fix 2026-10-22, part 6).
 * Replaces the per-product swatch/gallery scripts on product pages.
 * Config: snippets/hiba-product-families.liquid -> window.HIBA_PRODUCT_FAMILY = {name, handle, members[]}.
 * Data:   each member's /products/<handle>.js, read live (no hard-coded names, IDs or colours).
 * Rules:  - only variants with available === true are shown (on every member page);
 *         - variants with a photo and under 5 m in stock are excluded the same way (data: CFG.data[h].low);
 *         - swatch name = the variant's option value (single-option products) or its title;
 *         - swatch picture = the variant's featured image;
 *         - own-product swatches select in page (URL ?variant=, label, cart id, gallery);
 *           other members' swatches go to /products/<handle>?variant=<id>;
 *         - the gallery shows only the selected variant's photos: its featured media and the
 *           media that follow it up to the next variant's featured media (capped at the
 *           product's usual photos-per-variant, so orphan photos of deleted variants never mix in).
 */
(function () {
  'use strict';
  var CFG = window.HIBA_PRODUCT_FAMILY;
  if (!CFG || !CFG.handle || window.__hibaFamilyBooted) return;
  window.__hibaFamilyBooted = '20261024-fam8-u5';
  var ROOT = document.documentElement;

  /* ---------- styles ---------- */
  var css = [
    /* hide the old per-product option groups and remote overlays once our grid is ready */
    'html[data-hiba-fam="ready"] [data-hiba-high-variant-picker] > .hiba-native-variant-picker__group:not(.hiba-fam-group){display:none!important}',
    'html[data-hiba-fam="ready"] #hiba-remote-gallery-overlay,html[data-hiba-fam="ready"] #hiba-exact-remote-gallery,html[data-hiba-fam="ready"] #hiba-staged-remote-gallery-overlay,html[data-hiba-fam="ready"] #hiba-seamless-remote-gallery,html[data-hiba-fam="ready"] #hiba-cross-v4-remote-gallery,html[data-hiba-fam="ready"] #hiba-italian-one-gallery{display:none!important}',
    'html[data-hiba-fam="ready"] [data-hiba-fam-media="off"]{display:none!important}',
    '.hiba-fam-group .hiba-fam-swatch[data-hiba-fam-off]{display:none!important}',
    'html[data-hiba-fam="ready"] product-images [data-hiba-fam-media="on"]{display:block!important;visibility:visible!important;opacity:1!important}',
    'html[data-hiba-fam="ready"] product-images{display:block!important}',
    '.hiba-fam-group .hiba-fam-values{display:flex;flex-wrap:wrap;gap:8px;margin:0;padding:0}',
    '.hiba-fam-group .hiba-fam-swatch{cursor:pointer;-webkit-appearance:none;appearance:none}',
    '.hiba-fam-group .hiba-fam-swatch .hiba-color-swatch__dot{background-size:cover!important;background-position:center!important}',
    '.hiba-fam-designs{display:flex;flex-wrap:wrap;gap:10px}',
    '.hiba-fam-design-group .hiba-design-tile{width:var(--hiba-design-tile-size,90px);height:var(--hiba-design-tile-size,90px);flex:0 0 var(--hiba-design-tile-size,90px)}',
    '@media screen and (max-width:749px){.hiba-fam-design-group .hiba-design-tile{width:var(--hiba-design-tile-size,72px);height:var(--hiba-design-tile-size,72px);flex-basis:var(--hiba-design-tile-size,72px)}}',
    '.hiba-fam-design-group .hiba-design-tile[aria-pressed="true"]{border:2px solid #111!important}',
    '.hiba-fam-group .hiba-fam-swatch[aria-pressed="true"]{box-shadow:inset 0 0 0 1px rgba(0,0,0,.78),0 0 0 2px #fff,0 0 0 3px rgba(0,0,0,.78)!important}'
  ].join('');
  var st = document.createElement('style'); st.id = 'hiba-product-family-css'; st.textContent = css;
  document.head.appendChild(st);

  /* ---------- helpers ---------- */
  function cleanId(v) { var m = String(v == null ? '' : v).match(/\d+/g); return m ? m[m.length - 1] : ''; }
  function fetchProduct(h, attempt) {
    attempt = attempt || 0;
    return fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(h + ' ' + r.status); return r.json(); })
      .then(function (p) { p.__handle = h; return p; })
      .catch(function () {
        /* rate limits / network blips: retry with back-off instead of leaving the page unfiltered */
        if (attempt >= 4) return null;
        return new Promise(function (res) { setTimeout(res, 400 * Math.pow(2, attempt)); }).then(function () { return fetchProduct(h, attempt + 1); });
      });
  }
  function variantName(p, v) {
    return (p.options && p.options.length === 1) ? String(v.option1 || v.title) : String(v.title || v.option1 || '');
  }
  /* option roles, same rule as the native picker (code_7Wt7gt) */
  function roles(p) {
    var r = { design: -1, color: -1 };
    (p.options || []).forEach(function (o, i) {
      var n = String((o && o.name) || o || '').toLowerCase();
      if (r.design < 0 && (n.indexOf('design') > -1 || n.indexOf('desen') > -1 || n.indexOf('motif') > -1 || n.indexOf('d#') > -1)) r.design = i;
      else if (r.color < 0 && (n.indexOf('color') > -1 || n.indexOf('colour') > -1 || n.indexOf('renk') > -1 || n.indexOf('couleur') > -1 || n.indexOf('c#') > -1)) r.color = i;
    });
    if (r.color < 0) r.color = r.design === 0 ? ((p.options || []).length > 1 ? 1 : -1) : 0;
    return r;
  }
  /* legacy name -> HEX table of the native picker, used only when no data source has a HEX */
  var DICT = {"dark plum":"#786bc2","army green":"#4B5320","teal green":"#008080","almond brown":"#D2B48C","navy blue":"#000080","sand beige":"#C2B280","aqua blue":"#00FFFF","formal black":"#000000","moonlight blue":"#B0C4DE","dark brown":"#5C4033","baby blue":"#89CFF0","mint green":"#98FF98","dusty pink":"#D4A5A5","neon orange":"#FF5F1F","peach cream":"#FFDAB9","vanilla cream":"#F3E5AB","cappuccino brown":"#6F4E37"};
  function normHex(x) { x = String(x || '').trim(); if (/^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(x)) return x; if (/^([0-9a-f]{3}|[0-9a-f]{6})$/i.test(x)) return '#' + x; return ''; }
  function mapEntry(val) {
    var D = CFG.data || {}, own = D[CFG.handle], hit = null;
    var look = function (d) { var m = d && d.map; if (m && typeof m === 'object' && m[val]) return m[val]; return null; };
    hit = look(own);
    if (!hit) Object.keys(D).some(function (h) { hit = look(D[h]); return !!hit; });
    return hit;
  }
  /* where each swatch's colour really comes from, in priority order */
  function swatchFor(p, v, hasDesign, colorVal) {
    var D = (CFG.data || {})[p.__handle] || {}, vd = (D.v || {})[String(v.id)] || {}, me = mapEntry(colorVal), os = (D.os || {})[colorVal];
    var out = { hex: '', img: '', src: '', name: '' };
    var cands = hasDesign
      ? [[vd.h, 'variant-metafield'], [me && me.hex, 'color_swatch_map']]
      : [[me && me.hex, 'color_swatch_map'], [vd.h, 'variant-metafield']];
    cands.push([os && os.h, 'shopify-option-swatch']);
    for (var i = 0; i < cands.length && !out.hex; i += 1) { var hx = normHex(cands[i][0]); if (hx) { out.hex = hx; out.src = cands[i][1]; } }
    if (!out.hex && os && os.i) { out.img = os.i; out.src = 'shopify-option-swatch-image'; }
    var nm = (!hasDesign && me && me.name) || vd.n || colorVal;
    out.name = String(nm || colorVal || '');
    if (!out.hex && !out.img) { var dh = DICT[out.name.toLowerCase()] || DICT[String(colorVal).toLowerCase()] || normHex(colorVal); if (dh) { out.hex = dh; out.src = 'name-table'; } }
    if (!out.hex && !out.img && v.featured_image && v.featured_image.src) { out.img = thumb(v.featured_image.src); out.src = 'variant-image'; }
    return out;
  }
  function thumb(src) {
    if (!src) return '';
    src = String(src);
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=96';
  }
  function isLow(h, id) { var low = (((CFG.data || {})[h] || {}).low) || ''; return low.indexOf(',' + String(id) + ',') > -1; }
  /* every own variant is sold out or under 5 m: the product shows as sold out and cannot be added */
  function soldOut() {
    ROOT.setAttribute('data-hiba-fam-soldout', 'true');
    var txt = (window.HIBA_U5 && HIBA_U5.soldOut) || (window.theme && theme.strings && theme.strings.soldOut) || 'Sold out';
    if (!document.getElementById('hiba-u5-soldout-css')) {
      var st = document.createElement('style'); st.id = 'hiba-u5-soldout-css';
      st.textContent = '[data-hiba-fam-soldout] [data-hiba-fabric-box],html:has(form[data-hiba-u5-soldout]) [data-hiba-fabric-box],form[data-hiba-u5-soldout] [data-hiba-fabric-box],form[data-hiba-u5-soldout] button[type=submit],form[data-hiba-u5-soldout] button[name=add],form[data-hiba-u5-soldout] .shopify-payment-button,[data-hiba-fam-soldout] [data-hiba-high-variant-picker],[data-hiba-fam-soldout] variant-selects,[data-hiba-fam-soldout] .selector-wrapper{display:none!important}' +
        '.hiba-u5-soldout-btn{display:block;width:100%;padding:14px;margin:12px 0;border-radius:999px;background:#e5e5e5;color:#555;text-align:center;text-transform:uppercase;letter-spacing:.05em;cursor:not-allowed}';
      document.head.appendChild(st);
    }
    document.querySelectorAll('form[action*="/cart/add"][data-type="add-to-cart-form"], form[action*="/cart/add"][data-product-form]').forEach(function (form) {
      if (!form.querySelector('.hiba-u5-soldout-btn')) { var d = document.createElement('div'); d.className = 'hiba-u5-soldout-btn'; d.setAttribute('aria-disabled', 'true'); d.textContent = txt; form.appendChild(d); }
    });
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.setAttribute('data-hiba-u5-soldout', 'true');
      form.querySelectorAll('button[type="submit"], button[name="add"], input[type="submit"]').forEach(function (b) {
        b.disabled = true; b.setAttribute('aria-disabled', 'true');
        if (b.tagName === 'INPUT') b.value = txt; else b.textContent = txt;
      });
      form.querySelectorAll('[name="id"]').forEach(function (el) { el.dataset.hibaOriginalName = 'id'; el.removeAttribute('name'); });
      var pb = form.querySelector('.shopify-payment-button'); if (pb) pb.style.display = 'none';
    });
  }
  function urlVariant() { try { return new URL(location.href).searchParams.get('variant') || ''; } catch (e) { return ''; } }

  /* ---------- gallery: media groups per variant ---------- */
  function buildGroups(p) {
    var media = (p.media || []).map(function (m) { return String(m.id); });
    var anchors = {};
    (p.variants || []).forEach(function (v) { var id = v.featured_media && cleanId(v.featured_media.id); if (id) anchors[id] = true; });
    var idx = [];
    media.forEach(function (id, i) { if (anchors[id]) idx.push(i); });
    var gaps = {};
    for (var k = 0; k < idx.length; k += 1) {
      var g = (k + 1 < idx.length ? idx[k + 1] : media.length) - idx[k];
      gaps[g] = (gaps[g] || 0) + 1;
    }
    var cap = 0, best = 0;
    Object.keys(gaps).forEach(function (g) { if (gaps[g] > best || (gaps[g] === best && +g < cap)) { best = gaps[g]; cap = +g; } });
    var groups = {};
    (p.variants || []).forEach(function (v) {
      var fid = v.featured_media && cleanId(v.featured_media.id);
      var start = fid ? media.indexOf(fid) : -1, list = [];
      if (start >= 0) {
        for (var i = start; i < media.length && list.length < (cap || 1e9); i += 1) {
          if (i > start && anchors[media[i]]) break;
          list.push(media[i]);
        }
      }
      groups[String(v.id)] = list;
    });
    return { groups: groups, media: media };
  }
  function galleryItems() {
    var out = [];
    document.querySelectorAll('product-images [data-media-id], product-thumbs [data-media-id], [data-hiba-mobile-hero-slide][data-media-id], .product__thumbs [data-media-id]').forEach(function (el) {
      var item = el.closest('.product__slide, .product__thumb, [data-hiba-mobile-hero-slide], [data-slide]') || el;
      out.push([item, cleanId(el.getAttribute('data-media-id'))]);
    });
    return out;
  }

  /* ---------- state ---------- */
  var own = null, entries = [], byId = {}, G = null, selectedId = '', box = null, labelEl = null, applying = false, anyDesign = false, dBox = null, dLabel = null, designs = [], curDesign = null;

  function setCart(id) {
    window.__hibaHighPickerCurrentVariantId = String(id);
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var hidden = form.querySelector('input.hiba-current-variant-id');
      if (!hidden) {
        hidden = document.createElement('input'); hidden.type = 'hidden'; hidden.className = 'hiba-current-variant-id';
        form.insertBefore(hidden, form.firstChild || null);
      }
      hidden.name = 'id'; hidden.value = String(id);
      form.dataset.hibaCurrentVariantId = String(id);
      form.querySelectorAll('[name="id"]').forEach(function (el) { if (el !== hidden) { el.value = String(id); el.dataset.hibaOriginalName = 'id'; el.removeAttribute('name'); } });
      form.querySelectorAll('select[data-hiba-original-name="id"], input[data-hiba-original-name="id"]').forEach(function (el) { if (el !== hidden) el.value = String(id); });
      form.dispatchEvent(new CustomEvent('hiba:variant-id-change', { bubbles: true, detail: { variantId: String(id), source: 'hiba-product-family' } }));
    });
    var pk = document.querySelector('[data-hiba-high-variant-picker]');
    if (pk) pk.dataset.selectedVariantId = String(id);
  }
  function setUrl(id) {
    try {
      var u = new URL(location.href);
      if (u.searchParams.get('variant') === String(id)) return;
      u.searchParams.set('variant', String(id));
      history.replaceState(history.state, '', u.toString());
    } catch (e) {}
  }
  function showLabel(text) { if (labelEl) labelEl.textContent = text || ''; }
  function applyGallery() {
    if (!G || !selectedId) return;
    var want = {}; (G.groups[selectedId] || []).forEach(function (m) { want[m] = true; });
    var hasOwn = Object.keys(want).length > 0;
    applying = true;
    galleryItems().forEach(function (pair) {
      /* a variant without photos shows only the product's main photo, never other variants' photos */
      var on = hasOwn ? !!want[pair[1]] : (pair[1] === G.media[0]);
      var v = on ? 'on' : 'off';
      if (pair[0].getAttribute('data-hiba-fam-media') !== v) pair[0].setAttribute('data-hiba-fam-media', v);
      if (on) { pair[0].classList.remove('media--hidden', 'hiba-mobile-hero-hidden'); pair[0].removeAttribute('hidden'); pair[0].removeAttribute('aria-hidden'); }
    });
    applying = false;
  }
  function select(id, opts) {
    var e = byId[id]; if (!e || e.handle !== CFG.handle) return;
    selectedId = String(id);
    curDesign = e.design || null;
    applyDesign();
    if (box) box.querySelectorAll('.hiba-fam-swatch').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.variantId === selectedId ? 'true' : 'false'); });
    showLabel(e.name);
    setCart(selectedId);
    if (!opts || opts.url !== false) setUrl(selectedId);
    applyGallery();
    try { window.scrollTo({ top: window.scrollY }); } catch (x) {}
  }
  function go(e) { location.assign('/products/' + encodeURIComponent(e.handle) + '?variant=' + encodeURIComponent(e.id)); }

  function swatchButton(e) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'hiba-color-swatch hiba-fam-swatch';
    b.title = e.name;
    b.setAttribute('aria-label', e.name);
    b.setAttribute('aria-pressed', 'false');
    b.dataset.variantId = e.id;
    b.dataset.handle = e.handle;
    b.dataset.own = e.handle === CFG.handle ? 'true' : 'false';
    b.dataset.hibaSwatchSrc = e.src || 'none';
    if (e.design) b.dataset.design = e.design;
    var dot = document.createElement('span');
    dot.className = 'hiba-color-swatch__dot';
    if (e.hex) {
      b.dataset.swatchColor = e.hex;
      b.style.setProperty('--hiba-color', e.hex);
    } else if (e.img) {
      b.dataset.swatchImage = e.img;
      var bg = 'url("' + e.img + '") center / cover no-repeat';
      b.style.setProperty('background', bg, 'important');
      dot.style.setProperty('background', bg, 'important');
    }
    b.appendChild(dot);
    return b;
  }
  function buildDesigns() {
    var seen = {};
    designs = [];
    entries.forEach(function (e) {
      if (!e.design) return;
      var d = seen[e.design];
      if (!d) { d = seen[e.design] = { key: e.design, name: e.designName || e.design, img: '', own: false }; designs.push(d); }
      if (!d.img && e.vimg) d.img = e.vimg;
      if (e.handle === CFG.handle) d.own = true;
    });
  }
  function designTile(d) {
    var t = document.createElement('button');
    t.type = 'button';
    t.className = 'hiba-design-tile hiba-fam-design';
    t.title = d.name; t.setAttribute('aria-label', d.name); t.setAttribute('aria-pressed', 'false');
    t.dataset.design = d.key;
    if (d.img) {
      var im = document.createElement('img');
      im.className = 'hiba-design-tile__image';
      var src = String(d.img); if (src.indexOf('//') === 0) src = 'https:' + src;
      var sep = src.indexOf('?') === -1 ? '?' : '&';
      im.src = src + sep + 'width=240'; im.srcset = src + sep + 'width=120 120w, ' + src + sep + 'width=240 240w';
      im.sizes = '(max-width: 749px) 72px, 90px'; im.alt = d.name; im.loading = 'lazy'; im.decoding = 'async';
      t.appendChild(im);
    } else {
      var fb = document.createElement('span'); fb.className = 'hiba-design-tile__fallback'; fb.textContent = d.name; t.appendChild(fb);
    }
    return t;
  }
  function designOf(key) { for (var i = 0; i < designs.length; i += 1) if (designs[i].key === key) return designs[i]; return null; }
  function showDesignLabel(text) { if (dLabel) dLabel.textContent = text || ''; }
  function applyDesign() {
    if (!anyDesign) return;
    if (dBox) dBox.querySelectorAll('.hiba-fam-design').forEach(function (t) { t.setAttribute('aria-pressed', t.dataset.design === curDesign ? 'true' : 'false'); });
    if (box) box.querySelectorAll('.hiba-fam-swatch').forEach(function (b) {
      if (b.dataset.design === curDesign) b.removeAttribute('data-hiba-fam-off'); else b.setAttribute('data-hiba-fam-off', '');
    });
    var d = designOf(curDesign); showDesignLabel(d ? d.name : '');
  }
  function pickDesign(key) {
    if (key === curDesign) return;
    var cur = byId[selectedId];
    var list = entries.filter(function (e) { return e.design === key; });
    var own = list.filter(function (e) { return e.handle === CFG.handle; });
    var pool = own.length ? own : list;
    var same = cur && pool.filter(function (e) { return e.name === cur.name; })[0];
    var withPh = pool.filter(function (e) { return e.handle !== CFG.handle || (G.groups[e.id] || []).length; })[0];
    var t = same || withPh || pool[0];
    if (!t) return;
    if (t.handle === CFG.handle) select(t.id); else go(t);
  }

  function render() {
    var picker = document.querySelector('[data-hiba-high-variant-picker]');
    var host = picker || document.querySelector('product-form, form[action*="/cart/add"]');
    if (!host) return false;
    if (!host.querySelector('.hiba-fam-group')) {
      var first = picker ? picker.firstChild : host.firstChild;
      if (anyDesign) {
        buildDesigns();
        var dg = document.createElement('div');
        dg.className = 'hiba-native-variant-picker__group hiba-fam-group hiba-fam-design-group';
        dg.setAttribute('data-hiba-fam-name', CFG.name);
        dLabel = document.createElement('div');
        dLabel.className = 'hiba-native-variant-picker__dynamic-label';
        dLabel.setAttribute('data-hiba-fam-design-label', '');
        dLabel.setAttribute('aria-live', 'polite');
        dBox = document.createElement('div');
        dBox.className = 'hiba-native-variant-picker__values hiba-fam-designs';
        dBox.setAttribute('role', 'group');
        designs.forEach(function (d) { dBox.appendChild(designTile(d)); });
        dg.appendChild(dLabel); dg.appendChild(dBox);
        (picker || host).insertBefore(dg, first);
        dBox.addEventListener('click', function (ev) {
          var t = ev.target.closest('.hiba-fam-design'); if (!t) return;
          ev.preventDefault(); ev.stopPropagation(); pickDesign(t.dataset.design);
        });
        dBox.addEventListener('mouseover', function (ev) { var t = ev.target.closest('.hiba-fam-design'); if (t) showDesignLabel(t.title); });
        dBox.addEventListener('focusin', function (ev) { var t = ev.target.closest('.hiba-fam-design'); if (t) showDesignLabel(t.title); });
        var dreset = function () { var d = designOf(curDesign); showDesignLabel(d ? d.name : ''); };
        dBox.addEventListener('mouseleave', dreset); dBox.addEventListener('focusout', dreset);
      }
      var group = document.createElement('div');
      group.className = 'hiba-native-variant-picker__group hiba-fam-group hiba-fam-color-group';
      group.setAttribute('data-hiba-fam-name', CFG.name);
      labelEl = document.createElement('div');
      labelEl.className = 'hiba-native-variant-picker__dynamic-label';
      labelEl.setAttribute('data-hiba-fam-label', '');
      labelEl.setAttribute('aria-live', 'polite');
      box = document.createElement('div');
      box.className = 'hiba-native-variant-picker__values hiba-fam-values';
      box.setAttribute('role', 'group');
      entries.forEach(function (e) { box.appendChild(swatchButton(e)); });
      group.appendChild(labelEl); group.appendChild(box);
      var after = (picker || host).querySelector('.hiba-fam-design-group');
      (picker || host).insertBefore(group, after ? after.nextSibling : first);
      box.addEventListener('click', function (ev) {
        var b = ev.target.closest('.hiba-fam-swatch'); if (!b) return;
        ev.preventDefault(); ev.stopPropagation();
        var e = byId[b.dataset.variantId]; if (!e) return;
        if (e.handle === CFG.handle) select(e.id); else go(e);
      });
      box.addEventListener('mouseover', function (ev) { var b = ev.target.closest('.hiba-fam-swatch'); if (b) showLabel(b.title); });
      box.addEventListener('focusin', function (ev) { var b = ev.target.closest('.hiba-fam-swatch'); if (b) showLabel(b.title); });
      var reset = function () { var e = byId[selectedId]; showLabel(e ? e.name : ''); };
      box.addEventListener('mouseleave', reset);
      box.addEventListener('focusout', reset);
    }
    return true;
  }

  /* every page of a family shows the PRIMARY product's title (never "- 2", "- Copy" or a sister title) */
  function fixTitle() {
    var P = CFG.primaryTitle, O = CFG.ownTitle;
    if (!P || !O || P === O) return;
    /* idempotent: text already showing P is kept, only bare O is replaced (O may be a prefix of P) */
    var rep = P.indexOf(O) > -1
      ? function (txt) { return String(txt).split(P).map(function (part) { return part.split(O).join(P); }).join(P); }
      : function (txt) { return String(txt).split(O).join(P); };
    document.querySelectorAll('[data-product-title]').forEach(function (el) { if (el.getAttribute('data-product-title') === O) el.setAttribute('data-product-title', P); });
    var nt = CFG.primaryDocTitle || rep(document.title); if (nt !== document.title) document.title = nt; /* browser tab = primary product's SEO title */
    var scope = document.querySelector('main') || document.body;
    var w = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null), n, hits = [];
    while ((n = w.nextNode())) { if (n.nodeValue && n.nodeValue.indexOf(O) > -1 && !(n.parentNode && /^(SCRIPT|STYLE)$/.test(n.parentNode.nodeName))) hits.push(n); }
    hits.forEach(function (t) { var nv = rep(t.nodeValue); if (nv !== t.nodeValue) t.nodeValue = nv; });
    document.querySelectorAll('img[alt]').forEach(function (im) { var na = rep(im.alt); if (na !== im.alt) im.alt = na; });
  }
  fixTitle();

  function boot(products) {
    own = null;
    products.forEach(function (p) {
      if (!p) return;
      if (p.__handle === CFG.handle) own = p;
      (p.variants || []).forEach(function (v) {
        if (v.available !== true) return; /* sold-out variants never show */
        if (isLow(p.__handle, v.id)) return; /* under-5 m variants with photos never show (snippets/hiba-under5.liquid) */
        var r = roles(p), opts = v.options || [v.option1, v.option2, v.option3];
        var cv = r.color > -1 ? String(opts[r.color] || '') : String(v.title || '');
        var dv = r.design > -1 ? String(opts[r.design] || '') : '';
        var hasD = r.design > -1;
        var sw = swatchFor(p, v, hasD, cv);
        var vd = (((CFG.data || {})[p.__handle] || {}).v || {})[String(v.id)] || {};
        var e = { id: String(v.id), handle: p.__handle, name: sw.name || variantName(p, v), hex: sw.hex, img: sw.img, src: sw.src,
          design: dv, designName: (vd.d || dv), vimg: (v.featured_image && v.featured_image.src) || '' };
        if (hasD) anyDesign = true;
        entries.push(e); byId[e.id] = e;
      });
    });
    if (!own) return;
    if (!entries.some(function (e) { return e.handle === CFG.handle; })) { soldOut(); [300, 900, 2000, 4000].forEach(function (d) { setTimeout(soldOut, d); }); return; }
    G = buildGroups(own);
    var tries = 0;
    (function mount() {
      if (!render()) { if (tries++ < 50) setTimeout(mount, 100); return; }
      ROOT.setAttribute('data-hiba-fam', 'ready');
      var pk = document.querySelector('[data-hiba-high-variant-picker]');
      var hasPh = function (id) { return G.groups[id] && G.groups[id].length > 0; };
      var ownE = entries.filter(function (e) { return e.handle === CFG.handle; });
      var initial = urlVariant();
      if (!(initial && byId[initial] && byId[initial].handle === CFG.handle)) {
        /* default (no ?variant): theme's default if it is available and has photos, else first available own variant with photos */
        var d = pk && pk.dataset.selectedVariantId;
        initial = (d && byId[d] && byId[d].handle === CFG.handle && hasPh(d)) ? d : ((ownE.filter(function (e) { return hasPh(e.id); })[0] || ownE[0] || {}).id);
      }
      if (initial) select(initial, { url: !!urlVariant() || initial !== (pk && pk.dataset.selectedVariantId) });
      else { soldOut(); [300, 900, 2000, 4000].forEach(function (d) { setTimeout(soldOut, d); }); }
      /* re-assert after late theme/legacy scripts (they may reset the gallery, cart id or label) */
      [300, 900, 2000, 4000].forEach(function (d) { setTimeout(function () { fixTitle(); if (selectedId) { setCart(selectedId); applyGallery(); applyDesign(); var e = byId[selectedId]; showLabel(e && e.name); } }, d); });
      var t = 0, gal = document.querySelector('product-images') || document.body;
      new MutationObserver(function () { if (applying) return; clearTimeout(t); t = setTimeout(applyGallery, 60); })
        .observe(gal, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'hidden', 'style'] });
    })();
  }

  Promise.all((CFG.members && CFG.members.length ? CFG.members : [CFG.handle]).map(fetchProduct)).then(boot);
})();
